import {MglFullscreenControl, MglMap, MglMarker, MglNavigationControl, MglPopup} from 'v-mapbox'
import MapsCommon from '@/app-core/mixins/maps/mapsCommon.js'
import MapsProviderEnum from '@/app-core/api/enums/MapsProviderEnum.js'
import {generateRandomId} from '@/app-theme/components/common/vue-snotify/util.js'
import {isFunction} from '@/app-core/lib/utils/type'

export default {
  name      : 'VMap',
  components: {
    MglMap,
    MglPopup,
    MglMarker,
    MglNavigationControl,
    MglFullscreenControl
  },
  directives: {},
  mixins    : [MapsCommon],
  enums     : {MapsProviderEnum},
  props     : {
    width: {
      type   : String,
      default: '100%'
    },
    height: {
      type   : String,
      default: '250px'
    },
    map: {
      type   : Object,
      default: () => {
        return {Instance: null}
      }
    },
    mapStyles: {
      type   : Boolean,
      default: true
    },
    mapStatic: {
      type   : Boolean,
      default: false
    },
    mapContainerId: {
      type   : String,
      default: `vmap-${generateRandomId()}`
    },
    mapProvider: {
      type   : Object,
      default: undefined,
      validator(value) {
        const validValues = ['mapbox', 'google']
        return validValues.includes(value)
      }
    },
    mapZoom: {
      type   : Number,
      default: 18
    },
    mapCenter: {
      type   : Object,
      default: function () {
        return {
          lat: this.AppConfig?.Marketplace?.Location?.Lat || 0,
          lng: this.AppConfig?.Marketplace?.Location?.Lng || 0
        }
      }
    },
    addressMarker: {
      type   : Object,
      default: function () {
        return {
          lat: this.AppConfig?.Marketplace?.Location?.Lat || 0,
          lng: this.AppConfig?.Marketplace?.Location?.Lng || 0
        }
      }
    },
    storeMarker: {
      type   : Object,
      default: function () {
        return {
          lat: this.AppConfig?.Marketplace?.Location?.Lat || 0,
          lng: this.AppConfig?.Marketplace?.Location?.Lng || 0
        }
      }
    },
    storeDeliveryAreas: {
      type   : Object,
      default: () => {
        return {
          Circles : [],
          Polygons: []
        }
      }
    },
    showAddressMarker: {
      type   : Boolean,
      default: false
    },
    showStoreMarker: {
      type   : Boolean,
      default: false
    },
    showStoreInfowin: {
      type   : Boolean,
      default: false
    },
    draggable: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {
      MapBoxStyles: {
        Active   : 'mapbox://styles/mapbox/streets-v12',
        Streets  : 'mapbox://styles/mapbox/streets-v12',
        Satellite: 'mapbox://styles/mapbox/satellite-streets-v12'
      },
      infoWinOpen: this.showStoreInfowin
    }
  },
  computed: {
    mapContainerStyle() {
      if (this.mapStatic) return `width: 100%; height: ${this.height}px;`

      return `width: ${this.width}; height: ${this.height};`
    },

    $mapProvider() {
      return this.mapProvider ? this.mapProvider : this.mapStatic ? this.staticMapsProvider : this.interactiveMapsProvider
    },

    storeAddressTitle() {
      //TODO: FIX THIS - MAYBE MULTIPLE STORES ???
      const street = '' //this.appConfig.LOCATION_DATA.Street.trim() ? this.appConfig.LOCATION_DATA.Street.trim() : ''
      const city = '' //this.appConfig.LOCATION_DATA.City.trim() ? street ? ', ' + this.appConfig.LOCATION_DATA.City.trim() : this.appConfig.LOCATION_DATA.City.trim() : ''
      return street + city
    },

    mapObj: {
      get() {
        return this.map
      },
      set(val) {
        this.$emit('update:map', val)
      }
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
    if (this.$mapProvider.Name === MapsProviderEnum.Google) {
      this.mapObj = Object.freeze({
        Instance: this.$refs?.gmap
      })
    }
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    toMapBoxPoint(point) {
      return [parseFloat(point?.lng || -1), parseFloat(point?.lat || -1)]
    },

    onMarkerDragEnd(e) {
      const latLng = {
        lat: isFunction(e?.marker?.getLngLat) ? e?.marker.getLngLat().lat : e.latLng.lat(),
        lng: isFunction(e?.marker?.getLngLat) ? e?.marker.getLngLat().lng : e.latLng.lng()
      }

      this.$emit('dragend', e, latLng, e?.marker, this.$mapProvider.Name)
    },

    onMapBoxMapLoaded(e) {
      this.mapObj = Object.freeze({
        Instance: e.map
      })
    }
  }
}
